/* ============================================================
   ARKAVEDA BUY BLOCK — VARIANT / QTY / PRICE
   Currency format: Rs. 1,234.00
============================================================ */
(function () {
  'use strict';

  function initArkBuyBlock(form) {
    if (!form || form.dataset.arkReady === 'true') return;

    form.dataset.arkReady = 'true';

    var sectionId = form.getAttribute('data-section-id');

    var variants = [];

    try {
      variants = JSON.parse(
        form.getAttribute('data-variants') || '[]'
      );
    } catch (e) {
      variants = [];
    }

    var select = form.querySelector('[data-ark-variant-select]');
    var qty = form.querySelector('[data-ark-qty]');
    var minus = form.querySelector('.ark-qty-minus');
    var plus = form.querySelector('.ark-qty-plus');

    /* ============================================================
       PRICE ELEMENTS
    ============================================================ */

    var priceEl = document.getElementById(
      'ProductPrice-' + sectionId
    );

    var compareEl = document.getElementById(
      'ComparePrice-' + sectionId
    );

    var discountEl = document.getElementById(
      'ArkMainDiscount-' + sectionId
    );

    var totalEl = document.getElementById(
      'ArkTotalPrice-' + sectionId
    );

    var totalCompareEl = document.getElementById(
      'ArkTotalCompare-' + sectionId
    );

    var totalDiscountEl = document.getElementById(
      'ArkTotalDiscount-' + sectionId
    );

    var totalPacksEl = document.getElementById(
      'ArkTotalPacks-' + sectionId
    );

    var selectedEl = form.querySelector(
      '[data-ark-selected-value]'
    );

    var radios = form.querySelectorAll(
      '.ark-count-radio'
    );

    var cards = form.querySelectorAll(
      '.ark-count-option'
    );

    var addToCartText =
      form.getAttribute('data-add-text') ||
      'Add to Cart';

    var soldOutText =
      form.getAttribute('data-soldout-text') ||
      'Sold Out';

    /* ============================================================
       ARKAVEDA MONEY FORMATTER
       Output:
       Rs. 588.00
       Rs. 1,050.00
       Rs. 1,338.00

       Does NOT use Shopify.formatMoney()
       Does NOT show ₹
       Does NOT show INR
    ============================================================ */

    function money(cents) {
      cents = Number(cents || 0);

      if (!isFinite(cents)) {
        cents = 0;
      }

      var amount = cents / 100;

      var formattedAmount = amount.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      return 'Rs. ' + formattedAmount;
    }

    /* ============================================================
       GET VARIANT
    ============================================================ */

    function getVariant(id) {
      id = String(id);

      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === id) {
          return variants[i];
        }
      }

      return null;
    }

    /* ============================================================
       DISCOUNT CALCULATION
    ============================================================ */

    function discount(price, compare) {
      price = Number(price || 0);
      compare = Number(compare || 0);

      if (!compare || compare <= price) {
        return 0;
      }

      return Math.round(
        ((compare - price) * 100) / compare
      );
    }

    /* ============================================================
       CURRENT VARIANT
    ============================================================ */

    function currentVariant() {
      return select
        ? getVariant(select.value)
        : null;
    }

    /* ============================================================
       SYNC OFFER CARDS
    ============================================================ */

    function syncCards(variant) {
      cards.forEach(function (card) {
        card.classList.toggle(
          'is-selected',
          !!(
            variant &&
            String(
              card.getAttribute('data-variant-id')
            ) === String(variant.id)
          )
        );
      });

      if (selectedEl && variant) {
        selectedEl.textContent = variant.title;
      }

      radios.forEach(function (radio) {
        radio.checked = !!(
          variant &&
          String(radio.value) === String(variant.id)
        );
      });
    }

    /* ============================================================
       UPDATE ALL PRICES
    ============================================================ */

    function update(variant) {
      if (!variant) return;

      /* ----------------------------------------------------------
         QUANTITY
      ---------------------------------------------------------- */

      var quantity = parseInt(
        qty && qty.value,
        10
      );

      if (!quantity || quantity < 1) {
        quantity = 1;

        if (qty) {
          qty.value = 1;
        }
      }

      /* ----------------------------------------------------------
         VARIANT PRICE
      ---------------------------------------------------------- */

      var price = Number(
        variant.price || 0
      );

      var compare = Number(
        variant.compare_at_price || 0
      );

      /* ----------------------------------------------------------
         DISCOUNT
      ---------------------------------------------------------- */

      var pct = discount(
        price,
        compare
      );

      /* ----------------------------------------------------------
         TOTAL
      ---------------------------------------------------------- */

      var total = price * quantity;

      var totalCompare =
        compare > price
          ? compare * quantity
          : 0;

      /* ==========================================================
         MAIN PRODUCT PRICE
      ========================================================== */

      if (priceEl) {
        priceEl.textContent = money(price);

        priceEl.setAttribute(
          'content',
          (price / 100).toFixed(2)
        );
      }

      /* ==========================================================
         MAIN COMPARE PRICE
      ========================================================== */

      if (compareEl) {
        compareEl.textContent =
          compare > price
            ? money(compare)
            : '';

        compareEl.classList.toggle(
          'ark-hidden',
          !(compare > price)
        );
      }

      /* ==========================================================
         MAIN DISCOUNT
      ========================================================== */

      if (discountEl) {
        discountEl.textContent =
          pct
            ? '-' + pct + '%'
            : '';

        discountEl.classList.toggle(
          'ark-hidden',
          !pct
        );
      }

      /* ==========================================================
         TOTAL PRICE
      ========================================================== */

      if (totalEl) {
        totalEl.textContent = money(total);
      }

      /* ==========================================================
         TOTAL COMPARE PRICE
      ========================================================== */

      if (totalCompareEl) {
        totalCompareEl.textContent =
          totalCompare
            ? money(totalCompare)
            : '';

        totalCompareEl.classList.toggle(
          'ark-hidden',
          !totalCompare
        );
      }

      /* ==========================================================
         TOTAL DISCOUNT
      ========================================================== */

      if (totalDiscountEl) {
        totalDiscountEl.textContent =
          pct
            ? '-' + pct + '%'
            : '';

        totalDiscountEl.classList.toggle(
          'ark-hidden',
          !pct
        );
      }

      /* ==========================================================
         PACK COUNT
      ========================================================== */

      if (totalPacksEl) {
        totalPacksEl.textContent =
          quantity +
          (quantity === 1
            ? ' pack'
            : ' packs');
      }

      /* ==========================================================
         ADD TO CART
      ========================================================== */

      var add = form.querySelector(
        '.ark-add-button'
      );

      if (add) {
        add.disabled = !variant.available;

        add.classList.toggle(
          'btn--sold-out',
          !variant.available
        );

        var txt = add.querySelector(
          '[data-ark-add-text]'
        );

        if (txt) {
          txt.textContent =
            variant.available
              ? addToCartText
              : soldOutText;
        }
      }

      /* ==========================================================
         SYNC CARDS
      ========================================================== */

      syncCards(variant);
    }

    /* ============================================================
       OFFER RADIO CHANGE
    ============================================================ */

    radios.forEach(function (radio) {
      radio.addEventListener(
        'change',
        function () {
          if (!select) return;

          select.value = radio.value;

          update(
            getVariant(radio.value)
          );

          select.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
        }
      );
    });

    /* ============================================================
       OFFER CARD CLICK
    ============================================================ */

    cards.forEach(function (card) {
      card.addEventListener(
        'click',
        function (e) {
          var radio =
            card.querySelector(
              '.ark-count-radio'
            );

          if (
            radio &&
            !radio.disabled &&
            e.target !== radio
          ) {
            radio.checked = true;

            radio.dispatchEvent(
              new Event('change', {
                bubbles: true
              })
            );
          }
        }
      );
    });

    /* ============================================================
       PLUS BUTTON
    ============================================================ */

    if (plus) {
      plus.addEventListener(
        'click',
        function (e) {
          e.preventDefault();

          var n =
            parseInt(
              qty.value,
              10
            ) || 1;

          qty.value = n + 1;

          update(
            currentVariant()
          );
        }
      );
    }

    /* ============================================================
       MINUS BUTTON
    ============================================================ */

    if (minus) {
      minus.addEventListener(
        'click',
        function (e) {
          e.preventDefault();

          var n =
            parseInt(
              qty.value,
              10
            ) || 1;

          qty.value = Math.max(
            1,
            n - 1
          );

          update(
            currentVariant()
          );
        }
      );
    }

    /* ============================================================
       QUANTITY INPUT
    ============================================================ */

    if (qty) {
      qty.addEventListener(
        'input',
        function () {
          var value =
            parseInt(
              qty.value,
              10
            );

          if (
            isNaN(value) ||
            value < 1
          ) {
            qty.value = 1;
          }

          update(
            currentVariant()
          );
        }
      );
    }

    /* ============================================================
       VARIANT SELECT CHANGE
    ============================================================ */

    if (select) {
      select.addEventListener(
        'change',
        function () {
          update(
            getVariant(select.value)
          );
        }
      );
    }

    /* ============================================================
       INITIAL UPDATE
    ============================================================ */

    update(
      currentVariant()
    );
  }

  /* ==============================================================
     INITIALIZE ALL BUY BLOCKS
  ============================================================== */

  function initAll() {
    document
      .querySelectorAll(
        '.ark-product-buy-block .product-form'
      )
      .forEach(function (form) {
        initArkBuyBlock(form);
      });
  }

  /* ==============================================================
     DOM READY
  ============================================================== */

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }

  /* ==============================================================
     SHOPIFY THEME EDITOR
  ============================================================== */

  document.addEventListener(
    'shopify:section:load',
    initAll
  );

})();